import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <section id="contact" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 mb-8">Get in Touch</h2>
            <p className="text-gray-600 text-lg mb-12">
              궁금한 점이 있으시거나 상담을 원하시면 언제든지 연락주세요.
            </p>

            <div className="space-y-8">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className="ri-mail-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600 mb-1">이메일</p>
                  <a
                    href="mailto:contact@globalcareer.com"
                    className="text-gray-900 font-medium hover:text-teal-600 transition-colors"
                  >
                    contact@globalcareer.com
                  </a>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className="ri-kakao-talk-fill text-2xl text-teal-600"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600 mb-1">카카오톡</p>
                  <p className="text-gray-900 font-medium">@globalcareer</p>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-4 mt-12">
              <a
                href="#"
                className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl text-white"></i>
              </a>
              <a
                href="#"
                className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input
                  type="text"
                  placeholder="이름"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-0 py-4 bg-transparent border-b-2 border-gray-300 focus:border-teal-500 outline-none text-gray-900 placeholder-gray-500 transition-colors text-sm"
                  required
                />
              </div>

              <div>
                <input
                  type="email"
                  placeholder="이메일"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-0 py-4 bg-transparent border-b-2 border-gray-300 focus:border-teal-500 outline-none text-gray-900 placeholder-gray-500 transition-colors text-sm"
                  required
                />
              </div>

              <div>
                <textarea
                  placeholder="문의 내용"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  rows={6}
                  className="w-full px-0 py-4 bg-transparent border-b-2 border-gray-300 focus:border-teal-500 outline-none text-gray-900 placeholder-gray-500 resize-none transition-colors text-sm"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-teal-500 text-white py-4 rounded-lg font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                문의하기
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
